import * as React from "react";
const SvgFiBrandsTwitter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M21.543 7.104c.014.21.014.423.014.636 0 6.507-4.954 14.01-14.01 14.01v-.004A13.94 13.94 0 0 1 0 19.539q.584.07 1.172.07a9.88 9.88 0 0 0 6.115-2.111 4.93 4.93 0 0 1-4.6-3.42 4.9 4.9 0 0 0 2.223-.084A4.924 4.924 0 0 1 .96 9.167v-.062a4.9 4.9 0 0 0 2.235.616A4.927 4.927 0 0 1 1.67 3.148a13.98 13.98 0 0 0 10.148 5.145 4.929 4.929 0 0 1 8.391-4.491 9.9 9.9 0 0 0 3.127-1.195 4.95 4.95 0 0 1-2.165 2.724A9.9 9.9 0 0 0 24 4.555a10 10 0 0 1-2.457 2.549"
    />
  </svg>
);
export default SvgFiBrandsTwitter;
